import React from "react";

const SimpleToggle = ({
  checked = false,
  onChange = () => {},
  label,
  description,
  disabled = false,
}) => {
  const trackClasses = checked
    ? "border-[#FE731B] bg-[#FE731B] shadow-sm"
    : "border-gray-200 bg-gray-200";

  return (
    <div className="flex items-center gap-3">
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={label || "Toggle"}
        disabled={disabled}
        onClick={() => !disabled && onChange(!checked)}
        className={`relative inline-flex h-6 w-12 items-center rounded-full border-2 transition focus:outline-none focus:ring-2 focus:ring-indigo-400 ${
          disabled
            ? "cursor-not-allowed opacity-50"
            : "cursor-pointer active:scale-95"
        } ${trackClasses}`}
      >
        <span
          className={`inline-block h-5 w-5 rounded-full bg-white shadow transition-transform ${
            checked ? "translate-x-6" : "translate-x-0"
          }`}
        />
      </button>
      {(label || description) && (
        <div className="text-xs leading-tight">
          {label && (
            <p
              className={`font-semibold uppercase tracking-[0.3em] ${
                checked ? "text-[#FE731B]" : "text-gray-500"
              }`}
            >
              {label}
            </p>
          )}
          {description && (
            <p className="text-[11px] text-gray-400">{description}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default SimpleToggle;
